import React, { useState, useEffect } from "react";
import AdvancedButtonGroup from "../UniversalComponents/AdvancedButtonGroup";
import BasicSelect from "../Task/BasicSelect";
import { ReactComponent as NewArrowIcon } from "../../assets/images/icons/NewArrowIcon.svg";
import { ReactComponent as NewArrowGreen } from "../../assets/images/icons/NewArrowGreen.svg";
import { ReactComponent as NewArrowRed } from "../../assets/images/icons/NewArrowRed.svg";
import ToggleMultiSwitch from "../UniversalComponents/ToggleMultiSwitch";

const activeTabsList = [
  {
    label: "All",
    value: "all",
    statusColor: "#1D4469",
    textColor: "var(--color-primary)",
    bgColor: "var(--color-primary-active)",
    borderColor: "#1D4469",
    // hoverBgColor: "#E8EEF4",
    // hoverTextColor: "#1D4469"
  },
  {
    label: "Active",
    value: "active",
    statusColor: "#008937",
    textColor: "#00BA00",
    bgColor: "#D3F6CE",
    borderColor: "",
    //  hoverBgColor: "#DFF7E5",
    // hoverTextColor: "#00BA00",
  },
  {
    label: "Inactive",
    value: "inactive",
    statusColor: "#F84545",
    textColor: "#F84545",
    bgColor: "#FFE5E5",
    borderColor: "#F845454D",
    //  hoverBgColor: "#FFE5E5",
    // hoverTextColor: "#F84545",
  },
];

const ToDoActiveButton = React.memo(({ activeTab, handleTabClick }) => {
  const [currentTabIndex, setCurrentTabIndex] = useState(0);

  // useEffect(() => {
  //   handleTabClick(`${activeTabsList[0]?.value}`);
  // }, []);

  function handleButtonClick() {
    setCurrentTabIndex((prevIndex) => {
      const nextIndex = (prevIndex + 1) % activeTabsList.length;
      handleTabClick(`${activeTabsList[nextIndex]?.label}`);
      return nextIndex;
    });
  }

  return (
    // <button
    //   className={`cursor-pointer bg-[#1D4469] flex justify-center items-center rounded-md text-white font-500 px-2 py-1 capitalize hover:text-[#F1F1F1] hover:bg-[#1D4469] w-24
    //   `}
    //   style={{
    //     backgroundColor: activeTabsList[currentTabIndex]?.bgColor,
    //     color: activeTabsList[currentTabIndex]?.textColor,
    //     border: `1px solid ${activeTabsList[currentTabIndex]?.borderColor}`,
    //   }}
    //   onClick={handleButtonClick}
    // >
    //   {/* {activeTabsList[currentTabIndex]?.label} */}

    // </button>
    // <div className="w-28">
    //   <BasicSelect
    //     options={activeTabsList}
    //     selectedOptions={activeTabsList.filter((item) => item.value === activeTab)}
    //     value={activeTab}
    //     onChange={(e) => handleTabClick(`${e.target.value}`)}
    //     isButton={true}
    //     size="small"
    //     textBoldonHover={true}
    //   />
    // </div>

    <div
      className="flex justify-center items-center border border-[#E0E0E0] rounded-full bg-secondary w-full px-1 text-primary"
      role="group"
    >
      <ToggleMultiSwitch
        options={activeTabsList.map((tab) => ({
          label: (
            <span
              style={
                activeTab === tab.value
                  ? { backgroundColor: tab.bgColor, color: tab.textColor }
                  : { backgroundColor: "transparent", color: "#8E8E8E" }
              }
              className="w-[62px] py-1 text-sm font-medium rounded-full transition-all duration-200"
            >
              {tab.label}
            </span>
          ),
          value: tab.value,
        }))}
        onToggle={(value) => handleTabClick(value)}
        defaultValue={activeTab}
        className="w-full h-[32px]"
      />
    </div>
  );
});

export default ToDoActiveButton;

// ${activeTabsList[currentTabIndex] === "active" ? " bg-[#7adfa7] text-white" : ""}
// ${activeTabsList[currentTabIndex] === "inactive" ? " bg-[#a2b7c4] text-[#1D4469]" : ""}
// ${activeTabsList[currentTabIndex] === "all" ? " bg-[#ad5fa7] text-white" : ""}
